var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClamorlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 227,
    height: 227,
    viewBox: "0 0 227 227",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20.6553,
    y: 20.6552,
    width: 185.69,
    height: 185.69,
    rx: 46,
    fill: "#FA9418",
    stroke: "white",
    strokeWidth: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_158_2239)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.022 162.961C122.022 162.961 176.535 166.65 162.231 149.438C147.928 132.226 136.025 142.164 136.025 142.164L122.022 162.961Z",
    fill: "#E51E4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.548 170.25C120.055 170.25 103.171 167.62 100.291 167.216C79.0373 163.675 66.2255 155.077 62.0542 141.724C51.924 108.948 100.49 59.9874 102.575 57.9642C104.264 56.3457 106.846 56.3457 108.435 58.0654C110.024 59.7851 110.024 62.4152 108.336 64.0338C95.3251 77.0832 62.8487 116.13 69.9995 139.195C73.0783 149.209 83.8044 155.785 101.582 158.819C105.058 159.325 110.421 160.134 116.579 160.64C118.366 155.178 123.034 145.163 133.959 138.689C145.976 131.507 154.021 134.238 157.795 136.565C163.158 139.903 166.535 146.276 166.237 152.952C166.038 159.022 162.86 164.181 157.894 166.71C152.829 169.34 144.487 170.25 135.548 170.25ZM125.219 161.348C136.74 162.056 148.757 161.955 154.22 159.224C157.398 157.606 157.894 154.166 157.994 152.75C158.093 149.108 156.405 145.669 153.524 143.949C149.75 141.622 144.387 142.432 138.23 146.073C130.781 150.423 127.007 156.999 125.219 161.348Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_158_2239"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 105.672,
    height: 113.5,
    fill: "white",
    transform: "translate(60.6638 56.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClamorlogo);
export default __webpack_public_path__ + "static/media/clamorlogo.deb323c1ba742ec3695404ee047435de.svg";
export { ForwardRef as ReactComponent };